import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import Arrow from "../../../public/images/Arrow";
import Logo from "../../../public/images/Logo";
import MapIcon from "../../../public/images/MapIcon";
import Phone from "../../../public/images/Phone";
import Users from "../../../public/images/Users";
import AnimatedWords from "../../helpers/AnimatedWords";
import FormWrapper from "../../helpers/FormVoip/FormWrapper";
import CircleChatIcon from "./../../../public/images/CircleChatIcon";
import QuestionsIcon from "./../../../public/images/QuestionsIcon";
import StarsIcon from "./../../../public/images/StarsIcon";
import VoipIcon from "./../../../public/images/VoipIcon";
import "./header.scss";

export default function Header() {
  const [formOpen, setFormOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const navRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!navRef.current?.contains(e.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);
    return () =>
      document.removeEventListener("pointerdown", handleClickOutside);
  }, []);

  const toggleMenu = (name) => {
    setOpenMenu((prev) => (prev === name ? null : name));
  };

  const closeMenu = () => setOpenMenu(null);

  return (
    <header>
      <NavLink to="/" onClick={closeMenu}>
        <Logo />
      </NavLink>

      <nav ref={navRef}>
        <div className="navigation">
          <button
            type="button"
            onClick={() => toggleMenu("company")}
            className={openMenu === "company" ? "isActive" : ""}
          >
            <span>Company</span>
            <Arrow active={openMenu === "company"} />
          </button>

          {openMenu === "company" && (
            <div className="navigation__list">
              <NavLink to="/contacts" onClick={closeMenu}>
                <Phone color="#603CFF" />
                <div className="navigation__list__text">
                  <p>Contact us</p>
                  <span>Get in touch with our team</span>
                </div>
              </NavLink>

              <NavLink to="/about" onClick={closeMenu}>
                <Users />
                <div className="navigation__list__text">
                  <p>About us</p>
                  <span>Our mission, vision, and values</span>
                </div>
              </NavLink>

              <NavLink to="/roadmap" onClick={closeMenu}>
                <MapIcon />
                <div className="navigation__list__text">
                  <p>Road map</p>
                  <span>Our journey and future milestones</span>
                </div>
              </NavLink>
            </div>
          )}
        </div>
        <div className="navigation">
          <button
            type="button"
            onClick={() => toggleMenu("services")}
            className={openMenu === "services" ? "isActive" : ""}
          >
            <span>Our services</span>
            <Arrow active={openMenu === "services"} />
          </button>

          {openMenu === "services" && (
            <div className="navigation__list">
              <NavLink to="/voip" onClick={closeMenu}>
                <VoipIcon />
                <div className="navigation__list__text">
                  <p>Voip</p>
                  <span>Get in touch with our team</span>
                </div>
              </NavLink>

              <NavLink to="/apps" onClick={closeMenu}>
                <QuestionsIcon />
                <div className="navigation__list__text">
                  <p>App</p>
                  <span>Our mission, vision, and values</span>
                </div>
              </NavLink>

              <NavLink to="/services/cloud" onClick={closeMenu}>
                <CircleChatIcon />
                <div className="navigation__list__text">
                  <p>Cloud</p>
                  <span>Our journey and future milestones</span>
                </div>
              </NavLink>

              <NavLink to="/services/im" onClick={closeMenu}>
                <CircleChatIcon />
                <div className="navigation__list__text">
                  <p>IM</p>
                  <span>Our journey and future milestones</span>
                </div>
              </NavLink>

              <NavLink to="/services/ai" onClick={closeMenu}>
                <StarsIcon />
                <div className="navigation__list__text">
                  <p>AI</p>
                  <span>Our journey and future milestones</span>
                </div>
              </NavLink>
            </div>
          )}
        </div>
        <div className="navigation">
          <button
            type="button"
            onClick={() => toggleMenu("community")}
            className={openMenu === "community" ? "isActive" : ""}
          >
            <span>Community</span>
            <Arrow active={openMenu === "community"} />
          </button>

          {openMenu === "community" && (
            <div className="navigation__list">
              <NavLink to="/blog" onClick={closeMenu}>
                <VoipIcon />
                <div className="navigation__list__text">
                  <p>Blog</p>
                  <span>Insights, stories, and updates</span>
                </div>
              </NavLink>

              <NavLink to="/faq" onClick={closeMenu}>
                <QuestionsIcon />
                <div className="navigation__list__text">
                  <p>FAQs</p>
                  <span>Everything you need to know</span>
                </div>
              </NavLink>

              <a
                href="https://forum.x-cloud.info/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                <CircleChatIcon />
                <div className="navigation__list__text">
                  <p>Forum</p>
                  <span>Connect, share, and grow together</span>
                </div>
              </a>
            </div>
          )}
        </div>

        <NavLink to="/prices" onClick={closeMenu}>
          Pricing
        </NavLink>
      </nav>

      <button className="customLink" onClick={() => setFormOpen(true)}>
        Need better <AnimatedWords />
      </button>

      {formOpen && <FormWrapper onClose={() => setFormOpen(false)} />}
    </header>
  );
}
